export default __webpack_public_path__ + "static/media/cross-campus-bg.87d3f5d2.jpg";